export const API_URL = `${window.location.origin}/.netlify/functions/api`
export const PAGE_SIZE = 50

/** =====================
    React Query Keys
  ======================= */
export const QUERY_KEYS = {
  organizations: () => ["organizations"] as const,
  organization: (orgId: string) => [...QUERY_KEYS.organizations(), orgId],
  users: () => ["users"] as const,
  user: (userId: string) => [...QUERY_KEYS.users(), userId] as const,
  labReports: (orgId: string) => ["labReports", orgId] as const,
  labReport: (orgId: string, id: string) => ["labReport", orgId, id] as const,
  labReportByClientId: (clientId: string) => ["labReportByClientId", clientId] as const,
  patients: (orgId: string) => ["patients", orgId] as const,
  patient: (orgId: string, id: string) => [...QUERY_KEYS.patients(orgId), id] as const,
  patientLabValues: (orgId: string, id: string) => [...QUERY_KEYS.patient(orgId, id), "labValues"] as const,
  testConfigs: (orgId?: string) => ["testConfigs", orgId] as const,
  allTestConfigs: () => ["allTestConfigs"] as const,
  providerConfig: (orgId: string, provider: string) => ["providerConfig", orgId, provider] as const,
  subscription: (orgId: string) => ["subscription", orgId] as const,
  filterViews: (orgId: string, table: string) => ["filterViews", orgId, table] as const,
  conditions: (orgId: string) => ["conditions", orgId] as const,
  shareLinks: (orgId: string, resourceType?: string, resourceId?: string) =>
    ["shareLinks", orgId, resourceType, resourceId] as const,
  shareToken: (token: string) => ["shareToken", token] as const,
} as const
